import React, { useState, useId } from 'react';
import { useStyles } from "../styles/styles";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from '@mui/material/Grid';
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import {HtmlComponent} from "../global/components";

const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const setAgreed = props.setAgreed;
    const setOptionalAgreed = props.setOptionalAgreed;
    const court = props.court;
    const classes = useStyles;
    // See the note in Popup.jsx: MUI generates an aria-labelledby id that only a
    // DialogTitle would claim, so it has to be given a real target here.
    const titleId = useId();
    const [showCompleted, setShowCompleted] = useState(false);

    const getButtonsWidth = () => {
        if (court.bondAgreeNoCheckbox && !court.bondYesno) return 12;
        if (!court.bondAgreeNoCheckbox && court.bondYesno) return 12;
        return 6;
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth='md'
                fullWidth
                sx={classes.dialog}
                scroll="paper"
                aria-labelledby={titleId}
                slotProps={{
                    paper: {
                        'aria-label': 'Bond Conditions'
                    }
                }}
            >
                <span id={titleId} style={classes.visuallyHidden}>Bond Conditions</span>
                <DialogContent dividers>
                    <DialogContentText>
                        <Stack spacing={0} >
                            <HtmlComponent title='Mandatory Bond Conditions' component={court.bondAgree} />
                            { court.bondYesno &&
                                <HtmlComponent title='Optional Bond Conditions' component={court.bondYesno} />
                            }
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            alignItems: "top"
                        }}
                    >
                        { !court.bondAgreeNoCheckbox &&
                            <Grid size={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="agree"
                                            color='primary'
                                            sx={{marginLeft: {xs: '1rem', md: '1.5rem', lg: '2.5rem'}, paddingBottom: '.5rem', verticalAlign: 'top'}}
                                            defaultChecked={false}
                                            onChange={(e) => {setAgreed(e.target.checked); setShowCompleted(e.target.checked);}}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant='subtitle1'
                                            color='secondary'
                                            component='div'
                                            sx={{fontSize: {xs: '.9rem', sm: '1rem'}, lineHeight: {xs: '1rem', sm: '1.2rem'}, verticalAlign: 'top', padding: '.2rem 0'}}
                                        >
                                            I agree to the bond conditions above
                                        </Typography>
                                    }
                                    sx={{...classes.checkbox, paddingTop: '1rem'}}
                                />
                            </Grid>
                        }
                        { court.bondYesno &&
                            <Grid size={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="optionalAgree"
                                            color='primary'
                                            sx={{marginLeft: '0', verticalAlign: 'top', paddingBottom: '.5rem'}}
                                            defaultChecked={false}
                                            onChange={(e) => setOptionalAgreed(e.target.checked)}
                                        />
                                    }
                                    label={
                                        <Typography
                                            variant='subtitle1'
                                            color='secondary'
                                            component='div'
                                            sx={{fontSize: {xs: '.9rem', sm: '1rem'}, lineHeight: {xs: '1rem', sm: '1.2rem'}, verticalAlign: 'top', padding: '.2rem 0'}}
                                        >
                                            I agree to the optional bond conditions above
                                        </Typography>
                                    }
                                    sx={{...classes.checkbox, paddingTop: '1rem'}}
                                />
                            </Grid>
                        }
                        <Grid
                            sx={{textAlign: 'right', paddingRight: '3rem'}}
                            size={{
                                xs: 12,
                                md: getButtonsWidth()
                            }}>
                            <Button
                                variant='outlined'
                                color="primary"
                                sx={classes.squashedButton}
                                onClick={() => {setAgreed(false); setDone(true);}}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant='contained'
                                color="primary"
                                sx={classes.squashedButton}
                                disabled={!showCompleted && !court.bondAgreeNoCheckbox}
                                onClick={() => {setDone(true); setAgreed(true);}}
                            >
                                Continue
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Popup;